// Sets all the properties of of a deeply nested object to optional.
// Example: `DeepPartial<ChatTheme>`

export type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>
}

export function isDefined<T>(argument: T | undefined): argument is T {
  return argument !== undefined
}
